<template>
    <div class="preview-update">
        <div class="widget-contents-container">
            <div class="widget-header">
                <h3>Preview</h3>
                <div class="svg-container widget-close-button" @click="closeWidget">
                    <widget-close-svg />
                </div>
            </div>
            <div class="content-wrapper">
                <update-section 
                    variant="preview" 
                    :title="widget.title" 
                    :url-image="widget.image.url"
                    :body="widget.body" 
                    @click-button="closeWidget"
                >
                </update-section>
            </div>
            <div v-if="widget.buttonText" class="widget-footer">
                <div class="action-container">
                    <a :href="widget.buttonUrl | addWebsiteProtocol" class="link-destination" target="_blank" title="link-preview">
                        <app-button class="button-link">
                            {{ widget.buttonText }}
                        </app-button>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const AppButton = () => import('@/components/common/app-button');
const WidgetCloseSvg = () => import('@/components/svg/quick-add/widget-close-svg');
const UpdateSection = () => import('@/components/common/update-section')
import EventBus from '@/scripts/event-bus.js';

export default {
    name: 'preview-update',

    components: {
        'app-button': AppButton,
        'widget-close-svg': WidgetCloseSvg,
        'update-section': UpdateSection,
    },

    props: {
        widget: {
            type: Object,
            required: true
        }
    },

    methods: {
        closeWidget() {
            EventBus.$emit('close-widget', this.widget);
        },
    },
}
</script>

<style>
.preview-update.widget .widget-header {
    background: rgb(80, 82, 254);
    background: linear-gradient(90deg, rgba(80, 82, 254, 1) 0%, rgba(75, 201, 254, 1) 100%);
}

.preview-update .button-link,
.preview-update .action-container {
    width: 100%;
}

.preview-update .content-wrapper {
    padding: 0 !important;
}
</style>
